import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AddRemoveUserToSharedGroupService {
  constructor(private http: HttpClient) {}

  caseData = null;
  from = '';
  getMappedEmpListByGrpId(caseId): Observable<any> {
    let params = new HttpParams();
    params = params.append('refId', caseId);
    return this.http.get(`/admin/grp-dtls-by-caseId`, { params: params });
  }
}
